<template>
    <loader-dialog v-if="isLoading" />
</template>

<script>
import EventBus from '@/utilities/event-bus';
import LoaderDialog from './LoaderDialog.vue';
export default {
    components: { LoaderDialog },
    data() {
        return {
            isLoading: false,
        };
    },
    mounted() {
        // Listen for events to trigger the loader
        EventBus.on('show-operation-loader', () => {
            this.isLoading = true;
        });

        EventBus.on('hide-operation-loader', () => {
            this.isLoading = false;
        });
    },
};
</script>
